import {ColumnProps} from './../types/board.types';

export const BOARD_ADD_COLUMN = 'BOARD_ADD_COLUMN';
export const BOARD_EDIT_COLUMN = 'BOARD_EDIT_COLUMN';
export const BOARD_DELETE_COLUMN = 'BOARD_DELETE_COLUMN';
export const BOARD_COLUMN_SORTING = 'BOARD_COLUMN_SORTING';
export const BOARD_REORDER_COLUMN = 'BOARD_REORDER_COLUMN';
export const BOARD_UPDATE_AUTOMATION = 'BOARD_UPDATE_AUTOMATION';
export const BOARD_MERGE_AUTOMATION = 'BOARD_MERGE_AUTOMATION';
export const BOARD_UPDATE_TIMELINE = 'BOARD_UPDATE_TIMELINE';

interface AddBoardColumn
{
    type: typeof BOARD_ADD_COLUMN,
    payload: ColumnProps
}

interface EditBoardColumn
{
    type: typeof BOARD_EDIT_COLUMN,
    columnId: string,
    payload: ColumnProps
}

interface DeleteBoardColumn
{
    type: typeof BOARD_DELETE_COLUMN,
    columnId: string
}

interface SortingBoardColumn
{
    type: typeof BOARD_COLUMN_SORTING,
    source: any,
    destination: any,
    draggableId: string,
    action: string
}

interface ReorderBoardColumn
{
    type: typeof BOARD_REORDER_COLUMN,
    columns: ColumnProps[],
    viewAiPane?: any,
    boardTimeline?: any,
}

interface UpdateAutomationData
{
    type: typeof BOARD_UPDATE_AUTOMATION,
    columnId: string,
    isAutomationExist: boolean,
    data: any
}

interface MergeAutomationData
{
    type: typeof BOARD_MERGE_AUTOMATION,
    boardDetails: any,
    boardTimeline?: any
}

interface UpdateTimelineData
{
    type: typeof BOARD_UPDATE_TIMELINE,
    boardTimeline?: any
}

export type ColumnActionTypes = AddBoardColumn | EditBoardColumn | DeleteBoardColumn | SortingBoardColumn | ReorderBoardColumn 
| UpdateAutomationData | MergeAutomationData | UpdateTimelineData
